var React = require('react');

function BuildingIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.462 2L.538 2 0 0 14 0zM2 4v12h4.09v-2.77h1.818V16H12L12 4H2zm3.182 8.307H3.364v-1.845h1.818v1.845zm0-2.769H3.364V7.693h1.818v1.845zm0-2.769H3.364V4.923h1.818V6.77zm2.727 5.538H6.092v-1.845h1.817v1.845zm0-2.769H6.092V7.693h1.817v1.845zm0-2.769H6.092V4.923h1.817V6.77zm2.727 5.538H8.82v-1.845h1.817v1.845zm0-2.769H8.82V7.693h1.817v1.845zm0-2.769H8.82V4.923h1.817V6.77z"}));
}

BuildingIcon.defaultProps = {"viewBox":"0 0 14 16"};

module.exports = BuildingIcon;

BuildingIcon.default = BuildingIcon;
